/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Invite_InvalidInputs */

const cs_auth_invite_invalid = /** @type {(inputs: Auth_Invite_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento pozvánkový odkaz je neplatný nebo vypršel.`)
};

const en_auth_invite_invalid = /** @type {(inputs: Auth_Invite_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite link is invalid or has expired.`)
};

/**
* | output |
* | --- |
* | "This invite link is invalid or has expired." |
*
* @param {Auth_Invite_InvalidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_invite_invalid = /** @type {((inputs?: Auth_Invite_InvalidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Invite_InvalidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_invite_invalid(inputs)
	return cs_auth_invite_invalid(inputs)
});